import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AdminComponent } from './admin/admin.component';
import { AuthGuard } from './service/auth.guard';
import { AdminResolverService } from './admin/admin-resolver.service';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { DashboardComponent } from './common/dashboard/dashboard.component';
import { DashboardService } from './common/dashboard/dashboard.service';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { UserDashService } from './user-dashboard/user-dash.service';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import { AdmissionComponent } from './scholarship/admission/admission.component';
import { DonarComponent } from './scholarship/donar/donar.component';
import { DonarResolverService } from './scholarship/donar/donar-resolver.service';
import { FeesPaymentComponent } from './scholarship/fees-payment/fees-payment.component';
import { FeesPaymentService } from './scholarship/fees-payment/fees-payment.service';
import { PaymentListComponent, DialogReceipt } from './scholarship/payment-list/payment-list.component';
import { PaymentPendingService } from './scholarship/payment-list/payment-pending.service';
import { AdoptListComponent } from './scholarship/adopt-list/adopt-list.component';
import { AdoptResolveService } from './scholarship/adopt-list/adopt-resolve.service';
import { StudentListComponent } from './scholarship/student-list/student-list.component';
import { StudentResolveService } from './scholarship/student-list/student-resolve.service';
import { AdoptComponent } from './scholarship/adopt/adopt.component';
import { ExpenseComponent } from './scholarship/expense/expense.component';
import { ExpenseResolveService } from './scholarship/expense/expense-resolve.service';
import { ExpenseListComponent } from './scholarship/expense-list/expense-list.component';
import { ExpenseListService } from './scholarship/expense-list/expense-list.service';
import { DueListComponent } from './scholarship/due-list/due-list.component';
import { DueListService } from './scholarship/due-list/due-list.service';
import { OldStudentComponent } from './scholarship/old-student/old-student.component';
import { RefundListComponent } from './scholarship/refund-list/refund-list.component';
import { RefundListService } from './scholarship/refund-list/refund-list.service';
import { DonarListComponent } from './scholarship/donar-list/donar-list.component';
import { ScholarshipRefundComponent } from './scholarship/scholarship-refund/scholarship-refund.component';
import { ExpenseMasterComponent } from './master/expense-master/expense-master.component';
import { StudentPaymentComponent } from './scholarship/student-payment/student-payment.component';
import { RefundComponent } from './scholarship/refund/refund.component';

const routes: Routes = [
  {path:'',redirectTo:'admin',pathMatch:'full'},
  {path:'login',component:LoginComponent},
  {
    path:'admin',
    component:AdminComponent,
    canActivate:[AuthGuard],
    children:[
      {
        path:'',
        redirectTo:'dashboard',
        pathMatch:'full'
      },
      {
        path:'dashboard',
        component:DashboardComponent,
        resolve:{dash:DashboardService}
      },
      {
        path:'updatePassword',
        component:UpdatePasswordComponent
      },
      {
        path:'admission',
        component:AdmissionComponent
      },
      {
        path:'donar',
        component:DonarComponent,
        resolve:{employee:DonarResolverService}
      },
      {
        path:'viewDonar',
        component:DonarListComponent,
        resolve:{employee:DonarResolverService}
      },
      {
        path:'donateMoney',
        component:FeesPaymentComponent,
        resolve:{feesPayment:FeesPaymentService}
      },
      {
        path:'payments',
        component:PaymentListComponent,
        resolve:{payment:PaymentPendingService
        }
      },
      {
        path:'adoptList',
        component:AdoptListComponent,
        resolve:{resolveList:AdoptResolveService
        }
      },
      {
        path:'studentList',
        component:StudentListComponent,
        resolve:{stud:StudentResolveService}
      },
      {
        path:'studentWithdraw',
        component:StudentPaymentComponent,
        resolve:{feesPayment:FeesPaymentService}
      },
      {
        path:"adopt",
        component:AdoptComponent
      },
      {
        path:"expenseMaster",
        component:ExpenseMasterComponent
      },
      {
        path:"expense",
        component:ExpenseComponent,
        resolve:{expense:ExpenseResolveService}
      },
      {
        path:"expenseList",
        component:ExpenseListComponent,
        resolve:{expenseList:ExpenseListService}
      },
      {
        path:"dueList",
        component:DueListComponent,
        resolve:{dueList:DueListService}
      },
      {
        path:"oldStudent",
        component:OldStudentComponent
      },
      {
        path:"refundList",
        component:RefundListComponent,
        resolve:{refund:RefundListService}
      },
      {
        path:"refund",
        component:ScholarshipRefundComponent,
        resolve:{feesPayment:FeesPaymentService}
      },
      {
        path:'regularRefund',
        component:RefundComponent,
        resolve:{feesPayment:FeesPaymentService}
      },
      {
        path:'view-receipt',
        component:DialogReceipt
      }


    ],
    resolve:{menuList:AdminResolverService}
  },
  {
    path:'userDashboard',
    component:UserDashboardComponent,
    resolve:{users:UserDashService}
  },
  { path: '**', redirectTo: '/', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule],
  providers:[{provide:LocationStrategy,useClass:HashLocationStrategy}]
})
export class AppRoutingModule { }
